'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveBlockReasonId = exports.ActiveBlockReason = void 0;
var ActiveBlockReason;
(function (ActiveBlockReason) {
    ActiveBlockReason["UserNotVerified"] = "USER_NOT_VERIFIED";
})(ActiveBlockReason = exports.ActiveBlockReason || (exports.ActiveBlockReason = {}));
var ActiveBlockReasonId;
(function (ActiveBlockReasonId) {
    ActiveBlockReasonId[ActiveBlockReasonId["MultipleAccounts"] = 4] = "MultipleAccounts";
    ActiveBlockReasonId[ActiveBlockReasonId["BonusAbuse"] = 5] = "BonusAbuse";
    ActiveBlockReasonId[ActiveBlockReasonId["SuspectedFruad"] = 6] = "SuspectedFruad";
    ActiveBlockReasonId[ActiveBlockReasonId["ConfirmedFraud"] = 7] = "ConfirmedFraud";
    ActiveBlockReasonId[ActiveBlockReasonId["FalseRegistration"] = 8] = "FalseRegistration";
    ActiveBlockReasonId[ActiveBlockReasonId["Underage"] = 9] = "Underage";
    ActiveBlockReasonId[ActiveBlockReasonId["Other"] = 10] = "Other";
    ActiveBlockReasonId[ActiveBlockReasonId["UserNotVerified"] = 15] = "UserNotVerified";
    ActiveBlockReasonId[ActiveBlockReasonId["PoliticallyExposedPerson"] = 48] = "PoliticallyExposedPerson";
})(ActiveBlockReasonId = exports.ActiveBlockReasonId || (exports.ActiveBlockReasonId = {}));
